import { ReactNode } from 'react';
import { InThisNavItem } from '../programs/InThisNav';
import { HubOutlineNode, outlineBranchVisible } from '../../utils/hubChapter';
import NestedSectionRail from './NestedSectionRail';
import StickySectionHeading from './StickySectionHeading';

export function toolkitNavItems(
  nodes: HubOutlineNode[],
  idFor: (node: HubOutlineNode) => string,
  activeId: string | null,
  filtering: boolean
): InThisNavItem[] {
  return nodes.filter((node) => outlineBranchVisible(node, filtering)).map((node) => {
    const id = idFor(node);
    const children = toolkitNavItems(node.children, idFor, activeId, filtering);
    return {
      id,
      label: node.label,
      current: activeId === id,
      children: children.length > 0 ? children : undefined,
    };
  });
}

export default function ToolkitSectionTree({
  nodes,
  idFor,
  renderEntry,
  filtering,
  level = 0,
}: {
  nodes: HubOutlineNode[];
  idFor: (node: HubOutlineNode) => string | undefined;
  renderEntry: (node: HubOutlineNode) => ReactNode;
  filtering: boolean;
  level?: number;
}) {
  const visible = nodes.filter((node) => outlineBranchVisible(node, filtering));
  if (visible.length === 0) return null;

  return (
    <div className={level === 0 ? 'space-y-12' : 'space-y-8'}>
      {visible.map((node) => {
        const children = node.children.filter((child) => outlineBranchVisible(child, filtering));
        const hasNest = children.length > 0;
        const titleClass = level === 0 ? 'text-2xl font-bold text-gray-900' : 'text-xl font-semibold text-gray-900';
        return (
          <section key={node.id} id={idFor(node)} className="scroll-mt-24">
            <StickySectionHeading
              level={level}
              as={level === 0 ? 'h2' : 'h3'}
              nested={hasNest}
              className={titleClass}
            >
              {node.label}
            </StickySectionHeading>
            {hasNest ? (
              <NestedSectionRail>
                {renderEntry(node)}
                <ToolkitSectionTree
                  nodes={children}
                  idFor={idFor}
                  renderEntry={renderEntry}
                  filtering={filtering}
                  level={level + 1}
                />
              </NestedSectionRail>
            ) : (
              <div className="mt-3">{renderEntry(node)}</div>
            )}
          </section>
        );
      })}
    </div>
  );
}
